import {map} from 'lodash';

import {Accordion, AccordionDetails, AccordionTitle, Icon} from 'components';
import {DomainInfo} from 'types';

type Props = {
    infos: DomainInfo[];
    className?: string;
    renderCreatedBy: (eid: number) => React.ReactElement;
    renderCreatedAt: (date: Date) => string;
    onDelete: (index: number) => void;
}

export const WhitelistGrid: React.FC<Props> = ({infos, renderCreatedBy, renderCreatedAt, className, onDelete}) => (
    <div className={className}>
        {map(infos, (info, index) => (
            <Accordion key={info.id || info.domain} className='tw-mb-2'>
                <AccordionTitle>
                    <div className='tw-flex tw-justify-between'>
                        {info.domain}
                        <Icon stopPropagation name='delete' color='alert' onClick={() => onDelete(index)} />
                    </div>
                </AccordionTitle>
                <AccordionDetails>
                    {renderCreatedBy(info.createdBy)}
                    <div className='tw-flex tw-items-center tw-mt-2'>
                        <Icon name='calendar' className='tw-ml-2 tw-mr-4' />
                        {renderCreatedAt(info.createdAt)}
                    </div>
                    {info.description &&
                        <div className='tw-flex tw-items-center tw-mt-2'>
                            <Icon name='chat' className='tw-ml-2 tw-mr-4' />
                            {info.description}
                        </div>}
                </AccordionDetails>
            </Accordion>
        ))}
    </div>
);